import React from "react";



export default function ActivateNEWstudent() {
    return (
        <div>
            <h4><b>Activate New Students</b></h4>
        </div>
    )
}
